"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MoreDetailsModalSections;
(function (MoreDetailsModalSections) {
    MoreDetailsModalSections["PriceDetails"] = "price-details";
    MoreDetailsModalSections["NewPrice"] = "new-price";
    MoreDetailsModalSections["GreatDeal"] = "great-deal";
    MoreDetailsModalSections["Availability"] = "availability";
    MoreDetailsModalSections["EvTax"] = "ev-tax";
})(MoreDetailsModalSections || (MoreDetailsModalSections = {}));
exports.default = MoreDetailsModalSections;
//# sourceMappingURL=ModalSections.js.map